module.exports = __webpack_public_path__ + "static/pic12-1106170dc745f3480d159dc7ae842274.png";